import { useEffect, useRef } from 'react';

import { MAILBOX_AUTO_SYNC_INTERVAL_MS } from '../helpers';

const useMailboxAutoSync = ({
    enabled,
    onSync,
    intervalMs = MAILBOX_AUTO_SYNC_INTERVAL_MS,
}) => {
    const onSyncRef = useRef(onSync);

    useEffect(() => {
        onSyncRef.current = onSync;
    }, [onSync]);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        let intervalId = null;

        const stop = () => {
            if (intervalId === null) {
                return;
            }

            window.clearInterval(intervalId);
            intervalId = null;
        };

        const start = () => {
            stop();
            intervalId = window.setInterval(() => {
                onSyncRef.current?.();
            }, intervalMs);
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                start();
            } else {
                stop();
            }
        };

        if (document.visibilityState === 'visible') {
            start();
        }

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            stop();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [enabled, intervalMs]);
};

export default useMailboxAutoSync;
